import React from "react";
import useLogistrationTest from "@/monarch/rules/logistrationTest/useLogistrationTest";
import useLogistrationPageRedesign from "@/monarch/rules/logistrationPageRedesign/useLogistrationPageRedesign";
import { useModalActions } from "@/contexts/AuthModalProvider";
import { useAuth } from "@/components/AuthProvider";

export type LogistrationModalType = "signin" | "register";

export function useLogistrationModal() {
  const {
    openLoginModal,
    openRegisterModal,
    closeModal,
    updateLoggedInStatus,
  } = useModalActions();

  const { isLoggedIn } = useAuth();

  const { isLoading: isLoadingTest, variant: testVariant } =
    useLogistrationTest();
  const { isLoading: isLoadingRedesign, variant: redesignVariant } =
    useLogistrationPageRedesign();
  const shouldShowModal =
    testVariant === "test" && redesignVariant === "popup" && !isLoggedIn;

  const openLogistrationModal = (
    e: React.MouseEvent | React.KeyboardEvent,
    type: LogistrationModalType,
    callback?: () => void,
  ) => {
    if (shouldShowModal) {
      e.preventDefault();
      if (type === "signin") {
        openLoginModal(callback);
      } else {
        openRegisterModal(callback);
      }
    }
  };

  const handleLogistrationModalClick = (
    e: React.MouseEvent,
    type: LogistrationModalType,
    callback?: () => void,
  ) => {
    openLogistrationModal(e, type, callback);
  };

  const handleLogistrationModalKeyDown = (
    e: React.KeyboardEvent,
    type: LogistrationModalType,
  ) => {
    if (e.key === "Enter" || e.key === " ") {
      openLogistrationModal(e, type);
    }
  };
  const isLoading = isLoadingTest || isLoadingRedesign;

  return {
    handleLogistrationModalClick,
    handleLogistrationModalKeyDown,
    shouldShowModal,
    isLoading,
    closeModal,
    updateLoggedInStatus,
  };
}
